/* Inline quick-add size strip on product cards (desktop).
   Reveals on photo hover; stacked option rows (Top / Bottom) + a ring add button beside them:
   the ring fills as required sizes are picked, then morphs into a black "+ price" pill when ready.
   Adds via /cart/add.js and refreshes the cart drawer silently (no drawer open). */
(function () {
  'use strict';
  var RESET_DELAY = 3200;
  var ADDED_DELAY = 3000;

  function getData(strip) {
    if (!strip.__qsData) {
      var parsed = {variants: []};
      try {
        parsed = JSON.parse(strip.querySelector('[data-strip-data]').textContent);
      } catch (e) {
        // leave empty
      }
      strip.__qsData = parsed;
    }
    return strip.__qsData;
  }

  function optValue(variant, i) {
    return i === 0 ? variant.o1 : variant.o2;
  }

  function buttons(strip, i) {
    return Array.prototype.slice.call(strip.querySelectorAll('[data-strip-opt="' + i + '"]'));
  }

  function selectedBtn(strip, i) {
    return strip.querySelector('[data-strip-opt="' + i + '"].is-selected');
  }

  function hasSecondRow(strip) {
    return !!strip.querySelector('[data-strip-opt="1"]');
  }

  function refreshAvailability(strip) {
    var data = getData(strip);
    [0, 1].forEach(function (i) {
      var btns = buttons(strip, i);
      if (!btns.length) return;
      var other = 1 - i;
      var otherSel = selectedBtn(strip, other);
      var otherValue = otherSel ? otherSel.getAttribute('data-strip-value') : null;
      btns.forEach(function (b) {
        var value = b.getAttribute('data-strip-value');
        var ok = data.variants.some(function (v) {
          return v.a && optValue(v, i) === value && (!otherValue || optValue(v, other) === otherValue);
        });
        b.disabled = !ok;
        if (!ok) b.classList.remove('is-selected');
      });
    });
  }

  function readyVariant(strip) {
    var data = getData(strip);
    var s0 = selectedBtn(strip, 0);
    if (!s0) return null;
    var v0 = s0.getAttribute('data-strip-value');
    if (!hasSecondRow(strip)) {
      return data.variants.filter(function (v) {
        return v.o1 === v0 && v.a;
      })[0] || null;
    }
    var s1 = selectedBtn(strip, 1);
    if (!s1) return null;
    var v1 = s1.getAttribute('data-strip-value');
    return data.variants.filter(function (v) {
      return v.o1 === v0 && v.o2 === v1 && v.a;
    })[0] || null;
  }

  function updateAddButton(strip) {
    var btn = strip.querySelector('[data-strip-add]');
    if (btn) btn.disabled = !readyVariant(strip);
    var rows = strip.querySelectorAll('.quick-strip__row').length;
    var picked = strip.querySelectorAll('.quick-strip__value.is-selected').length;
    var pct = rows ? Math.round((picked / rows) * 100) : 0;
    strip.style.setProperty('--qs-progress', pct + '%');
  }

  function reset(strip) {
    clearTimeout(strip.__qsTimer);
    strip.classList.remove('is-added');
    Array.prototype.slice.call(strip.querySelectorAll('.quick-strip__value.is-selected')).forEach(function (b) {
      b.classList.remove('is-selected');
    });
    // Back to the default selection (size S) rather than nothing
    Array.prototype.slice.call(strip.querySelectorAll('[data-strip-default]:not([disabled])')).forEach(function (b) {
      b.classList.add('is-selected');
    });
    refreshAvailability(strip);
    updateAddButton(strip);
    strip.querySelector('[data-strip-rows]').hidden = false;
    var msg = strip.querySelector('[data-strip-msg]');
    msg.hidden = true;
    msg.textContent = '';
  }

  function showMessage(strip, text) {
    strip.querySelector('[data-strip-rows]').hidden = true;
    var msg = strip.querySelector('[data-strip-msg]');
    msg.textContent = text;
    msg.hidden = false;
    clearTimeout(strip.__qsTimer);
    strip.__qsTimer = setTimeout(function () {
      reset(strip);
    }, RESET_DELAY);
  }

  function addToCart(strip, variantId) {
    var routes = (window.theme || {}).routes || {};
    var url = (routes.cart_add_url || '/cart/add') + '.js';
    var btn = strip.querySelector('[data-strip-add]');
    // Optimistic: show the check immediately; roll back to a message if the add fails
    if (btn) btn.disabled = true;
    strip.classList.add('is-added');
    clearTimeout(strip.__qsTimer);
    strip.__qsTimer = setTimeout(function () {
      strip.classList.remove('is-added');
      strip.__qsTimer = setTimeout(function () {
        reset(strip);
      }, 350);
    }, ADDED_DELAY);
    fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
    })
      .then(function (r) {
        return r.json().then(function (json) {
          return {ok: r.ok, json: json};
        });
      })
      .then(function (res) {
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        } else {
          strip.classList.remove('is-added');
          showMessage(strip, (res.json && res.json.description) || 'Sold out');
        }
      })
      .catch(function () {
        strip.classList.remove('is-added');
        showMessage(strip, 'Error \u2014 try again');
      });
  }

  // Grid adds (size strip, quick-add sheet) stay silent so shoppers keep browsing.
  // Product-page adds (main form, sticky bar) let the theme open the bag as usual.
  var lastAddSource = null;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-strip-add], [data-quick-add-btn], dialog[data-quick-add-modal] [data-add-to-cart], .product__page [data-add-to-cart], [data-add-to-cart-bar]');
    if (!b) return;
    lastAddSource = b.closest('.product__page, [data-add-to-cart-bar]') && !b.closest('dialog[data-quick-add-modal]') ? 'pdp' : 'grid';
  }, true);
  window.addEventListener('theme:product:added', function (e) {
    if (lastAddSource === 'pdp') { lastAddSource = null; return; }
    e.stopImmediatePropagation();
    e.stopPropagation();
    // (No extra cart refresh here: the theme's own add pipeline already rebuilt
    // the cart before this event, and a second rebuild made items flash.)
    // Close the quick-add sheet after a beat so shoppers land back on the collection
    setTimeout(function () {
      var dlg = document.querySelector('dialog[open][data-quick-add-modal]');
      if (!dlg) return;
      var closeBtn = dlg.querySelector('[data-quick-add-modal-close]');
      if (closeBtn) closeBtn.click();
      else if (typeof dlg.close === 'function') dlg.close();
    }, 700);
  }, true);

  // Express-checkout wallets in cart drawer/page: keep Shop Pay, Apple Pay and PayPal.
  // (Shopify injects these per payment settings; we hide the rest,
  // and hide the whole row when none of the kept wallets is offered on this device.)
  var KEEP_WALLETS = ['shop', 'apple', 'paypal'];
  function pruneWallets() {
    var lists = document.querySelectorAll('.additional-checkout-buttons [data-shopify-buttoncontainer], .additional-checkout-buttons ul');
    Array.prototype.slice.call(lists).forEach(function (list) {
      var anyVisible = false;
      Array.prototype.slice.call(list.children).forEach(function (item) {
        var html = (item.outerHTML || '').toLowerCase();
        var keep = KEEP_WALLETS.some(function (k) { return html.indexOf(k) !== -1; });
        if (!keep) {
          item.style.setProperty('display', 'none', 'important');
        } else {
          anyVisible = true;
        }
      });
      var wrap = list.closest('.additional-checkout-buttons');
      if (wrap) wrap.style.display = anyVisible ? '' : 'none';
    });
  }
  var pruneTimer = null;
  var pruneObserver = new MutationObserver(function () {
    clearTimeout(pruneTimer);
    pruneTimer = setTimeout(pruneWallets, 100);
  });
  function startPrune() {
    pruneObserver.observe(document.body, {childList: true, subtree: true});
    pruneWallets();
  }
  if (document.body) startPrune();
  else document.addEventListener('DOMContentLoaded', startPrune);

  // Swatch "+N" count: force it to act as a product link (the theme's own
  // click handler otherwise intercepts it to expand the swatch row)
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var countLink = e.target.closest('a.product-item__swatches__count');
    if (!countLink) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    var href = countLink.getAttribute('href');
    if (href) window.location.href = href;
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var addBtn = e.target.closest('[data-strip-add]');
    var valueBtn = e.target.closest('[data-strip-opt]');
    if (!addBtn && !valueBtn) return;
    var strip = (addBtn || valueBtn).closest('[data-quick-strip]');
    if (!strip) return;
    e.preventDefault();
    e.stopPropagation();
    if (strip.classList.contains('is-busy')) return;
    if (addBtn) {
      if (addBtn.disabled) return;
      var variant = readyVariant(strip);
      if (variant) addToCart(strip, variant.id);
      return;
    }
    if (valueBtn.disabled) return;
    var i = parseInt(valueBtn.getAttribute('data-strip-opt'), 10);
    buttons(strip, i).forEach(function (b) {
      b.classList.remove('is-selected');
    });
    valueBtn.classList.add('is-selected');
    refreshAvailability(strip);
    updateAddButton(strip);
  }, true);

  // Start fresh next time the pointer leaves the card (unless mid-add / showing the note)
  document.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var image = e.target.closest('.product-item__image');
    if (!image) return;
    if (e.relatedTarget && image.contains(e.relatedTarget)) return;
    var strip = image.querySelector('[data-quick-strip]');
    if (!strip || strip.classList.contains('is-busy') || strip.classList.contains('is-added')) return;
    var msg = strip.querySelector('[data-strip-msg]');
    if (msg && !msg.hidden) return;
    var changed = Array.prototype.some.call(strip.querySelectorAll('.quick-strip__value.is-selected'), function (b) { return !b.hasAttribute('data-strip-default'); });
    if (changed) reset(strip);
  });
})();